import useLocalStore from '../../../hooks/useLocalStore';
import FJScriptEditorInput from './FJScriptEditorInput';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSliceSlateEditorNodes } from '../../../redux/slices/FJSliceTextToVideo';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import FJConstant from '../../../constants/FJConstant';
import useDefaultFreeLimit from '../../../hooks/useDefaultFreeLimit.jsx';
import { TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE } from '../../../config/dataConfig/FJTextToVideoDataConfig.js';
const FJScriptEditorInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const slateEditorNodes = useSelector(state => state.textToVideo.slateEditorNodes);
    const freeNumCreationInfo = useSelector(state => state.textToVideo.freeNumCreationInfo);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);
    const setSlateEditorNodes = useCallback(
        nodes => {
            dispatch(setSliceSlateEditorNodes(nodes));
        },
        [dispatch],
    );
    const onGenerateScript = useCallback(() => {
        dispatch(FJActionTextToVideo.onTextToScriptAction());
    }, [dispatch]);
    const isEditScript = useMemo(() => {
        return textToVideoStep === FJConstant.STEP_TYPE_SCRIPTS_EDIT;
    }, [textToVideoStep]);

    const defaultFreeNumCreation = useDefaultFreeLimit(TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_SCRIPT);

    return (
        <FJScriptEditorInput
            slateEditorNodes={slateEditorNodes}
            setSlateEditorNodes={setSlateEditorNodes}
            onGenerateScript={onGenerateScript}
            creditNumber={creditNumber}
            freeTimes={freeNumCreationInfo.textToScript}
            isEditScript={isEditScript}
            defaultFreeNumCreation={defaultFreeNumCreation}
        />
    );
};

export default FJScriptEditorInputContainer;
